import React, { useEffect, useState } from "react";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { deleteBrandYaragh } from "Stores/actions";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import Translator from "Languages/Utility/Translator";
import * as Icons from 'react-bootstrap-icons';

function DeleteBrand({ reGetOnBack }) {
  const { dataRelationBrand, selectedBrandYaragh } = useSelector((state) => ({
    dataRelationBrand: state.yaragh.dataRelationBrand,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
  }));
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: selectedBrandYaragh.Id,
      };
      const res = await dispatch(deleteBrandYaragh(data));
      await reGetOnBack(true)
      if (res) {
        onShowAlert();
      }
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationBrand);
  }, [dataRelationBrand]);

  return (
    <>
      <MuiIconButton
        title={<Translator id={"delete"}/>}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill mx-1"
        onClick={onShowAlert}
        disabled={
          selectedBrandYaragh.Disable ||
          (selectedBrandYaragh.IsG && read("StypeU") !== "1")
        }
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id='relationAlert' />}
        relationData={deleteRelationData}
        loading={loading}
      />
    </>
  );
}

export default DeleteBrand;
